import { type MutationError, trpc } from '@/shared/api';

interface UseAddExhibitionProductOptions {
  readonly onSuccess?: () => void;
}

/** 공개 상품을 기획전에 묶는다. 비공개·중복은 서버가 거부한다. */
export const useAddExhibitionProduct = ({ onSuccess }: UseAddExhibitionProductOptions = {}) => {
  const mutation = trpc.productManagement.exhibitions.addProduct.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    addProduct: (exhibitionId: string, productId: string) =>
      mutation.mutate({ exhibitionId, productId }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 모달의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
